import { ProductComparisonContentComponent } from './product-comparison-content.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ ProductComparisonComponent: ProductComparisonContentComponent });
